import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../../common/services/navigation.service';
import { SearchList } from '../../../common/components/search-list/search-list';
import { VendorService } from '../../../supplier/services/vendor.service';
import { Vendor } from '../../../supplier/resources/vendor';
import { exportCsv } from 'util/createCsv';

@Component({
  selector: 'vendor-list',
  templateUrl: './vendor-list.component.html',
  styleUrls: ['./vendor-list.component.less']
})
export class VendorListComponent extends SearchList<Vendor> {

  constructor(navService: NavigationService, private service: VendorService, private router: Router) {
    super('VendorListComponent');
    navService.setPageTitle("Suppliers");
  }

  search(): void {
    this.results = null;
    this.service.search(this.searchString, this.pageNumber, this.sortTerm, this.sortDirection).subscribe(results => {
      this.searchResults = results;
      this.results = results.results

      // Latest cert expiration date is the cert date
      for (const vendor of this.results) {
        vendor.certificationDate = null;

        for (const cert of vendor.vendorCertificates)
          if (vendor.certificationDate === null || cert.expirationDate < vendor.certificationDate)
            vendor.certificationDate = cert.expirationDate;
      }
    });
  }

  onSelect(record: Vendor): void {
    this.router.navigate(['/supplier', record.vendorId]);
  }

  public getScoreStyle(score: number): any {
    return VendorService.getScoreStyles(score, true);
  }

  public getStatusColorClass(date: Date): string {
    return VendorService.getStatusColorClass(date);
  }

  generateExport() {
    this.service.getVendorActivity().subscribe(results => {
      const headers = ["Name", "Expires", "TotalOrders", "TotalDollars"];
      const data = results.map(row => [row.name, row.expires, row.totalOrders, row.totalDollars]);

      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      const title = `Vendor Activity ${year}.${month}.${day}`;
      exportCsv(title, data, headers);
    });
  }

}
